import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  Drawer,
  Form,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  DatePicker,
  InputNumber,
  Collapse,
} from 'antd';
import { useMounted } from '../../hooks/useMounted';
import IntlMessage from '../../components/IntlMessage';
import routeSegmentsApi from '../../api/route-segments';
import { momentLocalizer, Calendar } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import useTime from '../../hooks/useTime';
import rateApi from '../../api/rates';
import Currency from '../../components/Currency';
import UpdateRateForm from './UpdateRateForm';
import rateHistoriesApi from '../../api/rate-histories';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';

const { Option } = Select;
const SegmentCalendar = (props) => {
  const { open, onClose, currentData, onReload, reload } = props;
  const localizer = momentLocalizer(moment);
  const { convertToAnyTimezone, formatAsISOString } = useTime();
  const { isMounted } = useMounted();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [option, setOption] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState([]);
  const [isModalUpdate, setIsModalUpdate] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 100000,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
    filter_name: ['segment_id'],
    filter_value: [currentData?.id],
  });
  const [form] = Form.useForm();
  const intl = useIntl();
  const [openDraw, setOpenDraw] = useState(false);

  const onCloseDraw = () => {
    setOpenDraw(false);
  };
  const showDrawer = () => {
    if (currentData) {
      setOpenDraw(true);
    } else {
      Modal.warning({
        title: 'Please add segment before adding new rates',
        okText: intl.formatMessage({ id: 'global.close' }),
      });
    }
  };
  const [mode, setMode] = useState('date');
  // Jour = single calendar day only (based on selected date, not leftover Date range / all weekdays)
  const resolveDayModePayload = (values) => {
    const fromDate = values.from_date;
    if (mode === 'day') {
      const weekday = String(dayjs(fromDate).day());
      return {
        from_date: fromDate,
        to_date: fromDate,
        weekdays: [weekday],
      };
    }
    return {
      from_date: fromDate,
      to_date: values.to_date,
      weekdays: values.weekdays,
    };
  };
  const onChangeMode = (value) => {
    setMode(value);
    if (value === 'day') {
      const fromDate = form.getFieldValue('from_date') || dayjs();
      form.setFieldsValue({
        to_date: fromDate,
        weekdays: [String(dayjs(fromDate).day())],
      });
    } else if (value === 'date') {
      const fromDate = form.getFieldValue('from_date') || dayjs();
      form.setFieldsValue({
        to_date: dayjs(fromDate).add(30, 'day'),
        weekdays: ['0', '1', '2', '3', '4', '5', '6'],
      });
    }
  };
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      if (filter.filter_name) {
        let result = await rateApi.getAll(filter);
        let events = result.data;
        events = events.map((item) => {
          return {
            start: new Date(convertToAnyTimezone(item.date)),
            end: new Date(convertToAnyTimezone(item.date)),
            title: (
              <div
                style={{
                  padding: '0 5px',
                  backgroundColor: !item.status && '#999292ee',
                  height: '70px',
                }}>
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '8px',
                  }}>
                  <Currency
                    style={{ color: '#fff' }}
                    value={item.adult_price}
                  />
                  {/* )} */}
                </div>
              </div>
            ),
            ...item,
          };
        });
        setItems(events);
      }
      setLoading(false);
    }
    fetchData();
  }, [filter, options, reload]);

  const handleCancel = () => {
    onClose();
  };

  const handleEventClick = (event) => {
    // console.log(event);
    setSelectedEvent(event);
    setIsModalUpdate(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = {
          ...values,
          segment_id: currentData?.id,
        };
        const resolved = resolveDayModePayload(data);
        data.from_date = formatAsISOString(resolved.from_date);
        data.to_date = formatAsISOString(resolved.to_date);
        data.weekdays = resolved.weekdays;
        let rateHistoryPayload = { ...data };
        rateHistoryPayload.price = data.adult_price;
        delete rateHistoryPayload?.year;
        rateHistoryPayload.week_days = rateHistoryPayload.weekdays
          .map((item) => {
            if (`${item}` === '1') return 'Monday';
            if (`${item}` === '2') return 'Tuesday';
            if (`${item}` === '3') return 'Wednesday';
            if (`${item}` === '4') return 'Thursday';
            if (`${item}` === '5') return 'Friday';
            if (`${item}` === '6') return 'Saturday';
            return 'Sunday';
          })
          .join(', ');
        delete rateHistoryPayload?.weekdays;
        Promise.all([
          rateApi.create(data),
          rateHistoriesApi.create(rateHistoryPayload),
        ])
          .then(() => {
            setLoading(false);
            onCloseDraw();
            onReload();
            Modal.success({
              title: 'Success',
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            form.resetFields();
          })
          .catch((error) => {
            console.error(error);
            Modal.error({
              title: error.data.message,
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            setLoading(false);
          });
      })
      .catch(() => setLoading(false));
  };
  const handleCreateStatus = () => {
    let data = {};
    const segmentIds = currentData?.id;
    data.segment_id = segmentIds;
    const resolved = resolveDayModePayload({
      from_date: form.getFieldValue('from_date'),
      to_date: form.getFieldValue('to_date'),
      weekdays: form.getFieldValue('weekdays'),
    });
    data.weekdays = resolved.weekdays;
    data.from_date = formatAsISOString(resolved.from_date);
    data.to_date = formatAsISOString(resolved.to_date);
    data.status = form.getFieldValue('status');
    // data.cabin_id = cabin.id;
    // console.log(data);
    routeSegmentsApi
      .updateStatusRates(data)
      .then(() => {
        setLoading(false);
        Modal.success({
          title: 'Success',
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        onReload();
        onCloseDraw();
      })
      .catch((error) => {
        console.error(error);
        Modal.error({
          title: error.data.message,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      });
  };

  const itemsNest = [
    {
      key: '1',
      label: 'Status',
      children: (
        <>
          <Form.Item name="status">
            <Radio.Group>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Button type="primary" size="small" onClick={handleCreateStatus}>
            Update
          </Button>
        </>
      ),
    },
  ];
  return (
    <React.Fragment>
      <Modal
        title={<IntlMessage id="global.update" />}
        open={open}
        destroyOnClose={true}
        onCancel={handleCancel}
        width="80%"
        footer={[
          <Button key="submit" type="primary" htmlType="submit">
            {<IntlMessage id="global.save" />}
          </Button>,
        ]}>
        <Row justify="space-between">
          <Col span={18}>
            Segment: {currentData?.start_stop?.title} -{' '}
            {currentData?.end_stop?.title}
          </Col>
          <Col>
            <Space>
              <Button type="primary" size="small" onClick={showDrawer}>
                <IntlMessage id="global.add_new" />
              </Button>

              {/* <Button
                size="small"
                danger
                onClick={onClearRate}
                disabled={!option}>
                <IntlMessage id="global.clear" />
              </Button> */}
            </Space>
          </Col>
        </Row>
        <Calendar
          localizer={localizer}
          events={items}
          defaultDate={new Date()}
          startAccessor="start"
          endAccessor="end"
          culture={'vi'}
          timeslots={3}
          style={{ height: 770, width: '100%', marginTop: '16px' }}
          scrollToTime={new Date()}
          selectable={true}
          toolbar={true}
          // messages={messages}
          onSelectEvent={handleEventClick}
        />
        <Drawer
          title={`${currentData?.start_stop?.title} - ${currentData?.end_stop?.title}`}
          placement="right"
          onClose={onCloseDraw}
          open={openDraw}
          width="30%"
          footer={
            <Space>
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={handleSubmit}>
                {<IntlMessage id="global.save" />}
              </Button>
            </Space>
          }>
          <Form
            layout="vertical"
            form={form}
            initialValues={{
              weekdays: ['0', '1', '2', '3', '4', '5', '6'],
              status: 1,
              from_date: dayjs(),
              to_date: dayjs().add(30, 'day'),
              price: 1,
              seat: 1,
            }}
            labelAlign="left"
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}>
            <Row
              justify={'start'}
              align={'bottom'}
              gutter={[10, 10]}
              style={{ width: '100%' }}>
              <Col span={6}>
                <Form.Item
                  name={'mode'}
                  initialValue={'date'}
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfeild" />,
                    },
                  ]}>
                  <Select
                    placeholder="Select mode"
                    onSelect={onChangeMode}
                    options={[
                      {
                        value: 'date',
                        label: <IntlMessage id="global.date" />,
                      },
                      {
                        value: 'day',
                        label: <IntlMessage id="global.day" />,
                      },
                    ]}></Select>
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item
                  label={
                    mode === 'date' && <IntlMessage id="global.from_date" />
                  }
                  name="from_date"
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfield" />,
                    },
                  ]}>
                  <DatePicker
                    // showTime
                    format={'DD/MM/YYYY'}
                    style={{ width: '100%' }}
                    onChange={(date) => {
                      if (mode === 'day' && date) {
                        form.setFieldsValue({
                          to_date: date,
                          weekdays: [String(dayjs(date).day())],
                        });
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              {mode === 'date' && (
                <Col span={9}>
                  <Form.Item
                    label={<IntlMessage id="global.to_date" />}
                    name="to_date"
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id="global.requiredfield" />,
                      },
                    ]}>
                    <DatePicker
                      // showTime
                      format={'DD/MM/YYYY'}
                      style={{ width: '100%' }}
                      // onChange={handleDate}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>

            <Form.Item
              label={<IntlMessage id="global.weekdays" />}
              name="weekdays"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <Checkbox.Group
                style={{ width: '100%' }}
                //  onChange={onChange}
                value={['0', '1', '2', '3', '4', '5', '6']}>
                <Row>
                  <Col span={6}>
                    <Checkbox value="1" checked>
                      Mon
                    </Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="2" defaultChecked>
                      Tue
                    </Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="3">Wed</Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="4">Thu</Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="5">Fri</Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="6">Sat</Checkbox>
                  </Col>
                  <Col span={6}>
                    <Checkbox value="0">Sun</Checkbox>
                  </Col>
                </Row>
              </Checkbox.Group>
            </Form.Item>
            <Form.Item
              label={<IntlMessage id="global.adult_price" />}
              name="adult_price"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <InputNumber
                min={1}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                style={{ width: '100%' }}
              />
            </Form.Item>

            <Collapse
              items={itemsNest}
              style={{ marginTop: '20px' }}
              defaultActiveKey={'1'}
            />
          </Form>
        </Drawer>
        {isModalUpdate ? (
          <UpdateRateForm
            open={isModalUpdate}
            onClose={() => setIsModalUpdate(false)}
            currentData={selectedEvent}
            onReload={onReload}
          />
        ) : null}
      </Modal>
    </React.Fragment>
  );
};

export default SegmentCalendar;
